const APIURLS = {
    addDevice: '/addDevice',
    addDriver: '/addDriver',
    addFence: '/addDeviceGeoFence',
    addPoi: '/addPoi',
    clearAlerts: '/clearAlerts',
    addVehicle: '/addVehicle',
    addZone: '/addZone',
    assignVehicle: '/assignVehicle',
    assignZoneToPoi: '/assignZoneToPoi',
    createSession: 'createSession',
    deleteDevice: '/deleteDevice',
    deleteDriver: '/deleteDriver',
    deleteFence: '/deleteDeviceGeofence',
    deletePoi: '/deletePoi',
    deleteVehicles: '/deleteVehicle',
    deleteZone: '/deleteZone',
    editDevice: '/editDevice',
    getAllDevices: '/getAllDevices',
    getNotifications: '/getNotifications',
    toggleNotifications: '/toggleNotifications',
    getAlldrivers: '/getAlldrivers',
    getAllGeoFence: '/getDeviceGeofences',
    getAllPois: '/getAllPois',
    getAllVehicle: '/getVehicles',
    getAllZones: '/getAllZones',
    getUser: '/getUser',
    getVehicle: '/getVehicles',
    viewVehicles: '/viewVehicles',
    login: '/login',
    register: '/register',
    resendOtp: 'resendOtp',
    unAssignZoneToPoid: '/unAssignZoneToPoid',
    updateAvatar: 'updateAvatar',
    deleteUser: 'deleteUser',
    updateDriver: '/updateDriver',
    updateGeoFence: '/updateDeviceGeoFence',
    updatePoi: '/updatePoi',
    updateVehicle: '/updateVehicle',
    updateZone: '/updateZone',
    validateOtp: 'validateOtp',
    getAllDeviceAlerts: '/getAllDeviceAlerts',
    getUnfilteredDeviceAlerts:'/getUnfilteredDeviceAlerts',
    viewVehicles: '/viewVehicles',
    getDashboardInfoDetail: '/getDashBoardDetails',
    getPin: '/getPin',
    generatePin: '/generatePin',
    loginPin: '/loginPin',
    revokePin: '/revokePin',
    setSettings: "/setSettings"
};

export default APIURLS;
